import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const ReportLists = () => {
  const { t } = useTranslation();
  const reports = [
    {
      label: t("masters.headerTexts.travelAndFuel"),
      route: "/analytics/travelAndFuel",
    },
    {
      label: t("masters.headerTexts.costAnalyt"),
      route: "/analytics/costAnalytics",
    },
    {
      label: t("masters.headerTexts.safetyAnalyt"),
      route: "/analytics/safetyAnalytics",
    },
  ];
  const navigate = useNavigate();
  return (
    <div className="flex flex-col py-10 h-full dark:bg-darkModeBg bg-lightModeBg">
      <div className="mx-auto grid gap-3 grid-cols-2">
        <div className="col-span-2 leading-loose dark:bg-zinc-800 bg-reportsTitleBar dark:text-white text-black rounded-md py-3 mt-5">
          <label className="px-3">{t("masters.headerTexts.reports")}</label>
        </div>
        {reports.map((x) => (
          <button
            type="button"
            onClick={() => navigate(x.route)}
            className="flex-col col-span-1 w-64 h-32 border-2 hover:border-blue-700 dark:border-zinc-800 border-zinc-400 rounded-lg flex justify-center items-center dark:bg-zinc-900 bg-analyticsCards dark:text-white text-black hover:bg-gradient-to-b from-blue-700 to-zinc-900 gap-3"
          >
            {x.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ReportLists;
